import { Control, Controller, RegisterOptions } from "react-hook-form";
import { NGKindSelect, NGKindSelectProps } from "../../../../newcomponents/select/ngkindselect";

interface FormNGKindSelectProps<T = any> extends Omit<NGKindSelectProps<T>, "value" | "onChange"> {
  name: string;
  control: Control<any>;
  rules?: RegisterOptions;
  onChangeExtra?: (value: string, item: T) => void; // Custom handler for additional updates
}

export const FormNGKindSelect = <T = any>({ 
  name, 
  control, 
  rules, 
  onChangeExtra,
  ...props 
}: FormNGKindSelectProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <NGKindSelect<T>
          {...props}
          value={field.value || ""}
          onChange={(value, item) => {
            field.onChange(value);
            if (onChangeExtra) {
              onChangeExtra(value, item);
            }
          }}
          invalid={fieldState.invalid || !!fieldState.error}
        />
      )}
    />
  );
};
